<template>
  <div class="bg">
    <div :style="{background:dynamicColor.rgb}" class="bacColor">
      <img src="../../../static/images/bgrule2.png" alt="">
    </div>
    <div class="returnBut" @click="returnBut">
      <img src="../../../static/images/return_b.png" alt="">
      <p>返回</p>
    </div>
    <div class="information">

      {{str.title1}}
    </div>
    <div class="wrapCon">
      <div class="con">
        <div class="raidersCon">
          <ul>
            <li>
              <h3>{{str.title2}}</h3>
              <p>{{str.introduce2}}</p>
            </li>
            <li>
              <h3>{{str.title3}}</h3>
              <p>{{str.introduce3}}</p>
            </li>
            <li>
              <h3>{{str.bonusRuleTitle}}</h3>
              <p>{{str.bonusRule}}</p>
            </li>
            <li>
              <h3>{{str.bonusReceiveRuleTitle}}</h3>
              <p>{{str.bonusReceiveRule}}</p>
            </li>
            <li>
              <h3>{{str.contributionSourceTitle}}</h3>
              <p>{{str.contributionSource}}</p>
            </li>
            <li>
              <h3>{{str.reduceAndAddTitle}}</h3>
              <p>{{str.reduceAndAdd}}</p>
            </li>
          </ul>
          <p class="concludingRemarks concludingRemarks_">{{str.bottom}}</p>
          <!--					<p class="concludingRemarks concludingRemarks_s">天星社区！</p>-->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {Toast} from "vant";
  import cookie from "js-cookie";
  var mobile = cookie.get("xq-mobile");
  var appid = cookie.get("xq-appid");
  export default {
    name: "index",
    data() {
      return {
        tabStat: 0,
        str: {},
        dynamicColor: {},
      }
    },
    created(e) {
      this.dynamicColor = JSON.parse(localStorage.getItem('bakColor'));
      var apiName = this.API1url.API;
      this.$get(apiName.Raiders, {
        appid: appid,
        mobile: mobile
      }).then(res => {
        if (res.code == '0000') {
          console.log(res, "???")
          this.str = res.data;
        } else {
          Toast.fail('加载失败');
        }
      }).catch(res => {
        Toast.fail('网络错误');
      })
      this.$post(apiName.submit, {
        mobile: mobile,
        requestId: new Date().getTime().toString(),
        appId: '10000',
        list: [
          {
            no: '1',
            status: 1,
            type: 36,
            openId: '1',
            attach: ''
          }
        ],
        sign: "123456"
      }).then((res) => {
        if (res.code == "0000") {
        }
      });
    },
    methods: {
      tab(e) {
        this.tabStat = e;
      },
      returnBut() {
        if (this.$route.query.id == 1) {
          this.$router.replace('/?token=' + localStorage.getItem('token'));
        } else {
          this.$router.replace('/Dividends');
        }
      }
    }
  }
</script>

<style scoped>
  .bg {
    width: 100%;
    height: 100%;
    position: relative;
    /*left: 0;*/
    /*top: 0;*/
    /*right: 0;*/
    /*bottom: 0;*/
    /*background: ;*/
    /*background-size: 100% 100%;*/
    overflow-y: scroll;
  }

  .bacColor {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 668px;
    /*z-index: -1;*/
  }

  .bacColor > img {
    width: 100%;
    height: 100%;
  }

  .information {
    display: flex;
    font-size: 28px;
    /*font-weight: bold;*/
    color: #ffffff;
    margin: 68px 0 76px 32px;
    position: relative;
    z-index: 1;
  }

  .wrapCon {
    width: 93%;
    background: #FFFFFF;
    margin: 24px auto;
    overflow: hidden;
    position: relative;
    z-index: 1;
  }

  .raidersCon {
    width: 85%;
    margin: 24px auto;
  }

  .raidersCon > div {
    padding-bottom: 16px;
    font-size: 14px;
    border-bottom: 1px solid #e8e8e8;
  }

  .raidersCon > ul > li {
    margin-top: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e8e8e8;
  }

  .raidersCon > ul > li:nth-child(1) > p {
    color: #0d0d0d;
  }

  .raidersCon > ul > li > h3:nth-child(1) {
    font-size: 18px;
    margin-bottom: 16px;
  }

  .raidersCon > ul > li > p {
    font-size: 14px;
    color: #878787;
  }

  .raidersCon > ul > li:nth-child(6) {
    border: none;
  }

  .concludingRemarks {
    text-align: center;
    font-size: 12px;
    color: #878787;
  }

  .concludingRemarks_ {
    margin-bottom: 5px;
    margin-top: 24px;
  }

  .concludingRemarks_s {
    margin-bottom: 50px;
  }

  .returnBut {
    position: absolute;
    left: 20px;
    top: 16px;
    z-index: 99;
    display: flex;
    align-items: center;
  }

  .returnBut > img {
    width: 20px;
    height: 18px;
  }

  .returnBut > p {
    color: #ffffff;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/raiders/index.vue